import { createStyles, makeStyles } from "@material-ui/core";

import { RelodeTheme } from "..";

export const useGridStyles = makeStyles(
    (theme: RelodeTheme) =>
        createStyles({
            container: {
                margin: theme.spacing(3),
                flexGrow: 1,
                [theme.breakpoints.down("md")]: {
                    margin: theme.spacing(0, 1, 10, 1),
                },
            },
            oneColumn: {
                display: "grid",
                gridTemplateColumns: "1fr [last-column]",
                columnGap: theme.spacing(3),
                rowGap: theme.spacing(3),
            },
            oneColumnCondensedGap: {
                display: "grid",
                gridTemplateColumns: "1fr [last-column]",
                columnGap: theme.spacing(3),
                rowGap: theme.spacing(1),
            },
            twoColumn: {
                display: "grid",
                gridTemplateColumns: "1fr 1fr [last-column]",
                columnGap: theme.spacing(3),
                rowGap: theme.spacing(3),
                [theme.breakpoints.down("md")]: {
                    display: "block",
                },
            },
            twoColumnNoGap: {
                display: "grid",
                gridTemplateColumns: "1fr 1fr [last-column]",
                columnGap: theme.spacing(3),
                rowGap: theme.spacing(0),
            },
            threeColumn: {
                display: "grid",
                gridTemplateColumns: "1fr 1fr 1fr [last-column]",
                columnGap: theme.spacing(3),
                rowGap: theme.spacing(3),
            },
            fourColumn: {
                display: "grid",
                gridTemplateColumns: "1fr 1fr 1fr [last-column]",
                columnGap: theme.spacing(3),
                rowGap: theme.spacing(3),
            },
            entireRow: {
                gridColumnStart: 1,
                gridColumnEnd: "last-column",
            },
            spanTwoColumns: {
                gridColumnEnd: "span 2",
            },
            spanThreeColumns: {
                gridColumnEnd: "span 3",
            },
        }),
    { name: "GridStyles" }
);
